import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-submission-info-detail',
    templateUrl: './submission-info.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SubmissionInfoDetail {
    public subject = input<string | null>(null);
    public reason = input<string | null>(null);
    public shipmentRequiredByDate = input<Date | null>(null);

    protected shipmentDateDisplay = computed(() => {
        const date = this.shipmentRequiredByDate();
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    });
}
